import cookies from 'vue-cookies'
import store from '@/store/index'

const _baseAccountURL = process.env.VUE_APP_BASE_ACCOUNT_URL
const _baseURLAcceptHttp = process.env.VUE_APP_BASE_URL_EXCEPT_HTTP

const COOKIES_DOMAIN = location.hostname.includes(_baseURLAcceptHttp)
	? _baseURLAcceptHttp
	: location.hostname

const TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY
const LAB_KEY = process.env.VUE_APP_LAB_KEY
// const FILTER_KEY = process.env.VUE_APP_FILTER_KEY;
// const STORAGE_ID_KEY = process.env.VUE_APP_STORAGE_ID_KEY;
// const STORAGE_NAME_KEY = process.env.VUE_APP_STORAGE_NAME_KEY;
const SERVICE_URL = process.env.VUE_APP_SERVICE_URL

// cookies.config('30d'); // 쿠키 만료기간 30일
cookies.config(Infinity, null, COOKIES_DOMAIN)

const isLogin = () => {
	return !cookies.isKey(TOKEN_KEY) ? false : true
}

const logout = () => {
	deleteLocalStorage()
	deleteAllCookies()
	// goToSSOMain();
}

const getAccountUrl = () => {
	return _baseAccountURL
}

const getCurrentLabId = () => {
	return null
}

const getServiceUrl = () => {
	return SERVICE_URL
}

const setToken = token => {
	// 모바일 쪽으로 웹 로드가 되었다고 보내줌
	cookies.set(TOKEN_KEY, token)
}

const getToken = () => {
	return cookies.get(TOKEN_KEY)
}

const deleteLocalStorage = () => {
	localStorage.removeItem('isNotSeeAgain')
	localStorage.removeItem('GLOBAL_FILTER_CODE')
}

const deleteAllCookies = () => {
	cookies.keys().forEach(key => {
		cookies.remove(key)
	})
	// console.warn(cookies)
	// cookies.remove(TOKEN_KEY, null, COOKIES_DOMAIN);
	// cookies.remove(LAB_KEY, null, COOKIES_DOMAIN);
}

const goToSSOMain = url => {
	logout()
	location.replace(
		`${getAccountUrl()}/SignIn?redirect=${
			url ? encodeURIComponent(url) : window.location.origin
		}&pro=true`
	)
}

const goToSSOEmail = () => {
	location.replace(
		`${getAccountUrl()}/pro/EmailAuth?redirect=${
			window.location.origin
		}&pro=true&token=${getToken()}`
	)
}

const hasInstitutionId = () => {
	return store.getters['user/hasInstitutionId']
}

export {
	isLogin,
	getAccountUrl,
	getCurrentLabId,
	setToken,
	getToken,
	logout,
	deleteLocalStorage,
	deleteAllCookies,
	getServiceUrl,
	goToSSOMain,
	goToSSOEmail,
	hasInstitutionId,
	COOKIES_DOMAIN,
}
